import React, { useState, useEffect, ChangeEvent } from "react";
import { getUserBoard } from "../../services/user.service";
import { RouteComponentProps } from "react-router-dom";
import SideBar from "../FunctionalComponents/Sidebar";
import RouterProps from "../../types/router.type";

type Props = RouteComponentProps<RouterProps>;

const LeadGenPartner: React.FC<Props> = ({ history }) => {
    const [content, setContent] = useState<string>("");
    
    useEffect(() => {
        getUserBoard().then(
            (response: any) => {
                setContent(response.data.username);
            },
            (error) => {
                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (_content === "Unauthorized") {
                    localStorage.removeItem("user");
                    history.push("/login");
                    window.location.reload();
                }

                setContent(_content);
            }
        );
    }, [history]);

    return (
        <div className="for-height">
            <div className="col-md-12 col-12-new">
                <div className="card card-container2 new-card">
                    <h3 className="login-header">Lead Gen Partner</h3>
                    <div>
                        Here you create a lead-gen partner, each data record that is uploaded later must be assigned to a lead-gen partner. Furthermore, you can add screenshots of sweepstakes, DOI mail, etc. when creating each Lead-Gen partner.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeadGenPartner;